import { render } from "./RejectApproveShare.vue?vue&type=template&id=0197a277&ts=true"
import script from "./RejectApproveShare.vue?vue&type=script&lang=ts"
export * from "./RejectApproveShare.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__